// Parse "YYYY-MM-DD" as a local date. new Date("YYYY-MM-DD") is UTC midnight,
// which shows as the previous day in US timezones.
export const parseDate = (dateString) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString || '');
    if (!match) return new Date(dateString);
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};
